import {
  FETCH_USER_POINTS,
  FETCH_USER_POINTS_SUCCESS,
  FETCH_USER_POINTS_FAILURE
} from "./actionTypes"

const INIT_STATE = {
  totalPoints: 0,
  pendingPoints: 0,
  dailyMaxPoints: {}, // e.g., { "2024-10-01": 50 }
  loading: false,
  error: null,
}

const pointsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_POINTS:
      return { ...state, loading: true, error: null };
    case FETCH_USER_POINTS_SUCCESS:
      return {
        ...state,
        ...action.payload, // totalPoints, pendingPoints, dailyMaxPoints
        loading: false,
      };
    case FETCH_USER_POINTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default pointsReducer;




